<div class="page-content amazing-dashboard">
  <div class="header-row">
    <div class="header-info">
      <h1 class="font-bold text-title">dashboard</h1>
      <p class="page-subtitle">Bienvenu {{ username }}</p>
    </div>
    <!-- 		<div class="header-actions">
			<button class="btn">Exporter</button>
			<button class="btn">Nouveau budget</button>
		</div> -->
  </div>

  <!-- KPI row -->
  <div class="stats-grid">
    <div class="card kpi" *ngFor="let s of stats">
      <div class="card-body">
        <div class="kpi-left">
          <p class="kpi-title">{{ s.title }}</p>
          <p class="kpi-value">{{ s.value }}</p>
          <p
            class="kpi-delta"
            [ngClass]="{ positive: s.change > 0, negative: s.change < 0 }"
          >
            {{ s.change > 0 ? "+" : "" }}{{ s.change }}
            <small>{{ s.changeLabel }}</small>
          </p>
        </div>
        <div class="kpi-icon">
          <mat-icon>{{ s.icon }}</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!-- Middle content: chart + categories -->
  <div class="middle-grid">
    <div class="card chart-card">
      <div class="card-body">
        <div class="chart-header">
          <h3>Budget vs Réel</h3>
          <div class="legend">
            <span class="legend-box muted"></span> Budget
            <span class="legend-box primary"></span> Réel
          </div>
        </div>
        <div class="chart">
          <!-- Simple bar chart rendered with categories as months-like demo -->
          <div class="chart-bars">
            <div *ngFor="let c of budgetCategories" class="chart-bar-wrap">
              <div
                class="chart-bar"
                [style.height.%]="(c.spent / c.allocated) * 100"
              ></div>
              <div class="chart-label">{{ c.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card categories-card">
      <div class="card-body">
        <h3>Budget par poste</h3>
        <div class="category-list">
          <div *ngFor="let cat of budgetCategories" class="category-row">
            <div class="category-head">
              <div class="category-name">{{ cat.name }}</div>
              <div class="category-amount">
                {{ cat.spent.toLocaleString() }} XOF /
                {{ cat.allocated.toLocaleString() }} XOF
              </div>
            </div>
            <div class="progress-bar">
              <div
                class="progress-filled"
                [style.width.%]="(cat.spent / cat.allocated) * 100"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Transactions + Projects -->
  <div class="bottom-grid">
    <div class="card transactions-card">
      <div class="card-body">
        <h3>Transactions récentes</h3>
        <table class="tx-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Catégorie</th>
              <th>Date</th>
              <th>Status</th>
              <th class="text-right">Montant</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of transactions">
              <td>{{ tx.description }}</td>
              <td>{{ tx.category }}</td>
              <td>{{ tx.date }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="{
                    'badge-green': tx.status === 'completed',
                    'badge-yellow': tx.status === 'pending',
                    'badge-red': tx.status === 'failed',
                  }"
                  >{{ tx.status }}</span
                >
              </td>
              <td class="text-right">
                <span
                  [ngClass]="{
                    'tx-positive': tx.type === 'income',
                    'tx-negative': tx.type !== 'income',
                  }"
                >
                  {{ tx.type === "income" ? "+" : "-" }}
                  {{ tx.amount.toLocaleString() }} XOF
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card projects-card">
      <div class="card-body">
        <h3>Projets actifs</h3>
        <div class="projects-list">
          <div *ngFor="let p of activeProjects" class="project-row">
            <div class="project-info">
              <div class="project-name">{{ p.name }}</div>
              <div class="project-tasks">
                {{ p.tasksCompleted }}/{{ p.totalTasks }} tâches
              </div>
            </div>
            <div class="progress-bar small">
              <div class="progress-filled" [style.width.%]="p.progress"></div>
            </div>
            <div class="project-meta">
              {{ p.progress }}% • Échéance: {{ p.dueDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
